<div class="breadcrumb-header justify-content-between">
  <div class="my-auto">
    <div class="d-flex">
      <h4 class="content-title mb-0 my-auto">Administración</h4>
      <span class="text-muted mt-1 tx-13 ms-2 mb-0">/ Solicitud precios</span>
    </div>
  </div>
</div>

<div class="row row-sm">
  <div class="col-xl-12">
    <div class="card overflow-visible">
      <div class="card-body">

        @if (cargando) {
          <div class="text-center">
            <div class="spinner-grow" role="status">
              <span class="sr-only">Loading...</span>
            </div>
            <br>
              <p class="text-center">Consultando por favor espere...</p>
            </div>
          }

          @if (!cargando && solicitudes.length === 0) {
            <div class="empty-state">
              <div class="empty-state__icon">
                <i class="fa fa-inbox"></i>
              </div>
              <h5>No hay solicitudes pendientes</h5>
              <p>Cuando existan solicitudes de cambio de precio aparecerán aquí.</p>
            </div>
          }

          @if (!cargando && solicitudes.length > 0) {
            <div class="table-responsive d-none d-md-block">
              <table datatable [dtOptions]="dtOptions" class="table table-bordered table-striped table-hover dt-ext solicitudes-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>N° SOL.</th>
                    <th>Facturador</th>
                    <th>Sucursal</th>
                    <th>Fecha solicitada</th>
                    <th>Servicio</th>
                    <th>Precio normal</th>
                    <th>Precio solicitado</th>
                    <th>Código</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  @for (solicitud of solicitudes; track solicitud; let i = $index) {
                    <tr>
                      <td>{{ i + 1 }}</td>
                      <td>{{ solicitud.NUM_SOLPREC }}</td>
                      <td>{{ solicitud.NOM_SOLPREC }}</td>
                      <td>{{ solicitud.DIR_SURC || '-' }}</td>
                      <td>{{ solicitud.FEC_SOLPREC }}</td>
                      <td>{{ solicitud.SER_SOLPREC }}</td>
                      <td>{{ solicitud.NORM_SOLPREC | currency:'USD':'symbol':'1.2-2' }}</td>
                      <td>{{ solicitud.NUE_SOLPREC | currency:'USD':'symbol':'1.2-2' }}</td>
                      <td>{{ solicitud.COD_SOLSUC }}</td>
                      <td>
                        <div class="action-group">
                          <button
                            type="button"
                            class="btn btn-success btn-sm"
                            [disabled]="procesandoId === (solicitud.COD_SOLPREC + '')"
                            (click)="confirmarProcesarSolicitud(solicitud, 'aprobar')">
                            Aceptar
                          </button>
                          <button
                            type="button"
                            class="btn btn-danger btn-sm"
                            [disabled]="procesandoId === (solicitud.COD_SOLPREC + '')"
                            (click)="confirmarProcesarSolicitud(solicitud, 'rechazar')">
                            Rechazar
                          </button>
                        </div>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          }

          @if (!cargando && solicitudes.length > 0) {
            <div class="mobile-list d-md-none">
              @for (solicitud of solicitudes; track solicitud; let i = $index) {
                <article class="mobile-card">
                  <div class="mobile-card__head">
                    <span class="mobile-index">#{{ i + 1 }}</span>
                    <span class="mobile-number">{{ solicitud.NUM_SOLPREC }}</span>
                  </div>
                  <div class="mobile-card__title">{{ solicitud.SER_SOLPREC }}</div>
                  <div class="mobile-card__meta"><b>Facturador:</b> {{ solicitud.NOM_SOLPREC }}</div>
                  <div class="mobile-card__meta"><b>Sucursal:</b> {{ solicitud.DIR_SURC || '-' }}</div>
                  <div class="mobile-card__meta"><b>Normal:</b> {{ solicitud.NORM_SOLPREC | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="mobile-card__meta"><b>Solicitado:</b> {{ solicitud.NUE_SOLPREC | currency:'USD':'symbol':'1.2-2' }}</div>
                  <div class="mobile-card__meta"><b>Código:</b> {{ solicitud.COD_SOLSUC }}</div>
                  <div class="mobile-card__actions">
                    <button
                      type="button"
                      class="btn btn-success btn-sm"
                      [disabled]="procesandoId === (solicitud.COD_SOLPREC + '')"
                      (click)="confirmarProcesarSolicitud(solicitud, 'aprobar')">
                      Aceptar
                    </button>
                    <button
                      type="button"
                      class="btn btn-danger btn-sm"
                      [disabled]="procesandoId === (solicitud.COD_SOLPREC + '')"
                      (click)="confirmarProcesarSolicitud(solicitud, 'rechazar')">
                      Rechazar
                    </button>
                  </div>
                </article>
              }
            </div>
          }

        </div>
      </div>
    </div>
  </div>
